export const SET_CURRENTLY_LOADED_URL = 'PLAYER:SET_CURRENTLY_LOADED_URL';
export const SET_IS_WARMING_UP = 'PLAYER:SET_IS_WARMING_UP';
export const SET_SKIPS = 'PLAYER:SET_SKIPS';
export const STATION_LOADED = 'PLAYER:STATION_LOADED';
export const SET_SPEED = 'PLAYER:SET_SPEED';
export const SET_PLAYER_INTERACTED = 'PLAYER:SET_PLAYER_INTERACTED';
export const RESET_PLAYER_STATE = 'PLAYER:RESET_PLAYER_STATE';
